module.exports = __webpack_public_path__ + "img/krea-logo.1e9b185b.svg";